import * as React from "react";
import { endOfDay, format } from "date-fns";

import {
  CalendarIcon,
  CamIcon,
  ClockIcon,
  HospitalIcon,
  Spinner,
} from "../../shared/svgIcon";
import { cn, dateConvert } from "../../shared/utils";
import { Calendar } from "../ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { useRef } from "react";
import { useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { createRoom, scheduleAppointment } from "../../lib/api";
import { useStore } from "../../store";
import { toast } from "sonner";

export function AppointmentSummary(props) {
  let navigate = useNavigate();
  const { locationId: orgId } = useParams();
  const selectedAppointment = useStore((state) => state.selectedAppointment);
  const setSelectedAppointment = useStore((state) => state.setAppointment);
  const patientInfo = useStore((state) => state.patient);

  const selectedDateRef = useRef(null);
  const selectedTimeRef = useRef(null);

  const [currentDoctor, setCurrentDoctor] = React.useState(null);
  const [selectedDate, setSelectedDate] = React.useState(null);
  const [selectedTime, setSelectedTime] = React.useState(null);
  const [locationDetail, setLocationDetail] = React.useState(null);
  const [selectedType, setSelectedType] = React.useState(null);
  const [isLoading, setLoader] = React.useState(false);

  useEffect(() => {
    // console.log(id, "id");
    const currentDoctor = sessionStorage.getItem("selectedDoctor")
      ? JSON.parse(sessionStorage.getItem("selectedDoctor"))
      : null;
    const currentLocation = sessionStorage.getItem("selectedLocation")
      ? JSON.parse(sessionStorage.getItem("selectedLocation"))
      : null;
    const currentDate = sessionStorage.getItem("selectedDate")
      ? JSON.parse(sessionStorage.getItem("selectedDate"))
      : null;
    const currentTime = sessionStorage.getItem("selectedTime")
      ? JSON.parse(sessionStorage.getItem("selectedTime"))
      : null;
    const currentType = sessionStorage.getItem("selectedType")
      ? JSON.parse(sessionStorage.getItem("selectedType"))
      : null;

    setCurrentDoctor(currentDoctor);
    setLocationDetail(currentLocation);
    setSelectedDate(currentDate);
    setSelectedTime(currentTime);
    setSelectedType(currentType);
    
  }, []);

  useEffect(() => {
    if (selectedDateRef.current) {
      selectedDateRef.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [selectedDate]);
  useEffect(() => {
    if (selectedTimeRef.current) {
      selectedTimeRef.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [selectedTime]);
  const getStatus = (key) => {
    let status;
    switch (key) {
      case "confirmed":
        status = "doctor approved";
        break;
      case "requested":
        status = "Waiting for doctor approval";
        break;

      default:
        status = "Waiting for doctor approval";
        break;
    }
    return status;
  };

  const handlePayment = async () => {
    if (selectedDate && selectedTime && currentDoctor) {

      setLoader(true);
      let roomRes;
      if (selectedType == "virtual_visit") {
        const roomPayload = {
          // name:'prognosis',
          // start_time: Math.floor(new Date(time.slot_start).getTime() / 1000),
          end_time: Math.floor(
            new Date(selectedTime.slot_end).getTime() / 1000
          ),
        };
        roomRes = await createRoom(roomPayload);
      }
      setSelectedAppointment({
        ...selectedAppointment,
        consumer_id: patientInfo?.id,
        status: "requested",
        source: {
          identifier: orgId,
          name: "",
          classification: "consumer_portal",
          location: "",
        },
        payment_details: {},
        virtual_room_data: {
          name: '',
          url: '',
        },
      });
      const payload = {
        user_id: currentDoctor?.basic_details?.id,
        organization_id: orgId,
        date: dateConvert(new Date(selectedDate)),
        consumer_id: patientInfo?.id,
        start_time: selectedTime.slot_start,
        end_time: selectedTime.slot_end,
        appointment_type: selectedType,
        reason:selectedAppointment?.reason,
        documents: selectedAppointment?.documents || [],
        status: "requested",
        source: {
          identifier: orgId,
          name: "",
          classification: "consumer_portal",
          location: "",
        },
        payment_details: {},
        virtual_room_data: {
          name: roomRes?.name,
          url: roomRes?.url,
        },
      };
      const res = await scheduleAppointment(payload);
      if (res.isSuccess) {
        setLoader(false);
        toast('Appointment Scheduled successfully.')
        navigate("/Dashboard");
      } else {
        setLoader(false);
      }
    }
  };
  const handleGoBack = () => {
    navigate(-1);
  };
  const goToVitalHistory = () => {
    navigate("/vitalHistory?from=share");
  };
  const goToDocHistory = () => {
    navigate("/documentHistory?from=share");
  };
  return (
    <>
      <div className="bg-white min-sh-screen ">
        <div className="flex justify-between text-black p-4 pt-6 h-16 fixed max-w  z-50 w-full bg-white ">
          <div>
            <Link className="flex" to="#" onClick={handleGoBack}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="2"
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
                />
              </svg>
              <div className="pl-2 flex-1 mt-0.5">
                <h4 className="font-semibold text-sm">Appointment summary</h4>
              </div>
            </Link>
          </div>
        </div>
        <div
          className=" flex-1  hideScroll  text-gray-500  flex flex-col pt-16 p-4 pb-16"
          // style={{ height: "calc(100vh - 10px)" }}
        >
          {currentDoctor && (
            <>
              <div
                className={`bg-neutral-100  border shadow  rounded-[18px] p-4 mb-8`}
              >
                <div className="flex   justify-between ">
                  <div className="flex ">
                    <div className="w-[60px] h-[60px] rounded-full overflow-hidden">
                      {currentDoctor?.basic_details?.profile.avatar_url ? (
                        <img
                          className="w-full h-full object-cover"
                          src={currentDoctor?.basic_details?.profile.avatar_url}
                          alt={currentDoctor?.basic_details?.username}
                        />
                      ) : (
                        <img
                          className="w-full h-full object-cover"
                          src={"../../../images/user.svg"}
                          alt={currentDoctor?.basic_details?.username}
                        />
                      )}
                    </div>
                  </div>
                  <div className="flex  flex-col flex-1 pl-2">
                    <div className="flex flex-col p-2 ">
                      <div className="font-semibold text-slate-700">
                        {" "}
                        {currentDoctor?.basic_details?.name_prefix}{" "}
                        {currentDoctor?.basic_details?.profile.first_name}{" "}
                        {currentDoctor?.basic_details?.profile.middle_name}{" "}
                        {currentDoctor?.basic_details?.profile.last_name}
                      </div>
                      <div className="text-sm text-zinc-600 ">
                        {currentDoctor?.basic_details?.qualifications &&
                          currentDoctor?.basic_details?.qualifications.map(
                            (qualification, index) => (
                              <div key={index}>
                                <span
                                  key={index}
                                  className="text-neutral-500 text-sm font-normal"
                                >
                                  {qualification}
                                </span>{" "}
                                {index <
                                  currentDoctor?.basic_details?.qualifications
                                    .length -
                                    1 && <span className="pr-1">,</span>}
                              </div>
                            )
                          )}
                        {currentDoctor?.basic_details?.specialities &&
                          currentDoctor?.basic_details?.specialities.map(
                            (specialty, index) => (
                              <div key={index}>
                                <span className="pr-1">,</span>
                                <span
                                  key={index}
                                  className="text-neutral-500 text-sm font-normal"
                                >
                                  {specialty?.name}
                                </span>{" "}
                                {index <
                                  currentDoctor?.basic_details?.specialities
                                    .length -
                                    1 && <span className="pr-1">,</span>}
                              </div>
                            )
                          )}
                      </div>
                    </div>
                    <div className="flex items-center justify-between py-2">
                      <div className="flex flex-col h-full justify-between">
                        <div className="font-semibold text-slate-700 mb-2">
                          Type
                        </div>
                        <div
                          className={`flex items-center text-sm text-white py-1 px-2 rounded-xl border w-[110px] ${
                            selectedType == "virtual_visit"
                              ? "bg-green-500  border-green-500"
                              : "bg-orange-500 border-orange-500"
                          }`}
                        >
                          {selectedType == "virtual_visit" ? (
                            <CamIcon />
                          ) : (
                            <HospitalIcon />
                          )}{" "}
                          <p className="px-1">
                            {selectedType == "virtual_visit"
                              ? "Video call"
                              : "In Person"}
                          </p>
                        </div>
                      </div>
                      <div className="flex flex-col h-full justify-between ml-4">
                        <div className="font-semibold text-slate-700 mb-2">
                          Status
                        </div>
                        <div
                          className={` text-sm rounded-full  text-slate-700`}
                        >
                          {getStatus("requested")}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="w-full h-[0px] border-b-[1px] border-indigo-200 mb-2"></div>
                {selectedAppointment?.reason && <div className=" p-3 pb-1 mb-1  mt-1">
                  <div className="text-base font-semibold">
                    Reason for the visit
                  </div>
                  <span className="">
                      {selectedAppointment?.reason}
                    </span>
                </div>}
                <div className=" p-3 mb-4  mt-1">
                  <div className="text-base font-semibold">
                    {locationDetail?.organization_details?.name}
                  </div>

                  <div className="">
                    <span className="pr-2">
                      {locationDetail?.organization_details?.location}{" "}
                    </span>
                    <span className="pr-2">
                      {locationDetail?.organization_details?.address?.street},
                    </span>
                    <span className="pr-2">
                      {locationDetail?.organization_details?.address?.city},
                    </span>
                    <span className="pr-2">
                      {locationDetail?.organization_details?.address?.state}
                    </span>

                    <span className="pr-2">
                      {
                        locationDetail?.organization_details?.address
                          ?.postal_code
                      }
                    </span>
                  </div>

                  {locationDetail?.organization_details?.contact?.filter(
                    (e) => e.type == "phone"
                  ).length > 0 && (
                    <div className="location-phone webmd-row">
                      Tel:{" "}
                      <a
                        href={`tel:${
                          locationDetail?.organization_details?.contact?.find(
                            (contact) => contact.type === "phone"
                          )?.value
                        }`}
                        className=""
                      >
                        {
                          locationDetail?.organization_details?.contact?.find(
                            (contact) => contact.type === "phone"
                          )?.value
                        }
                      </a>
                    </div>
                  )}
                </div>
                <div className="text-sm font-semibold flex flex-col min-[420px]:flex-row min-[420px]:items-center  text-slate-700">
                  {selectedDate && (
                     <div className="flex items-center">
                      <ClockIcon className="mr-2" />

                      {/* <p className="pr-1 font-semibold text-base">
                        {format(new Date(selectedDate), "EEEE")}
                      </p>
                      <p className="font-semibold text-base">
                        {format(new Date(selectedDate), "dd")}
                      </p> */}
                      <p className="pr-1 font-semibold text-base">
                        {format(new Date(selectedDate), "MMM")}
                      </p>
                      <p className="font-semibold text-base">
                        {format(new Date(selectedDate), "dd")}
                      </p>
                      ,
                      <p className="pr-1 font-semibold text-base">
                        {format(new Date(selectedDate), "yyyy")}
                      </p>
                      <p className="pl-3 font-semibold text-base">
                        {format(new Date(selectedDate), "EEE")}
                      </p>
                      ,
                    </div>
                  )}

                  {/* <p className="px-1">{format(new Date(), "h:mm a")}</p> */}
                  {selectedTime && (
                    <div className="flex flex-row gap-2 font-semibold text-base pl-1">
                      <p>
                        {" "}
                        {format(new Date(selectedTime.slot_start), "h:mm a")}
                      </p>{" "}
                      <p>-</p>
                      <p>
                        {" "}
                        {format(new Date(selectedTime.slot_end), "h:mm a")}
                      </p>
                    </div>
                  )}
                </div>
                <div className="flex flex-1 justify-around space-x-4 mt-6">
                  <button
                    className=" border-2 bg-blue-800 rounded-[18px] text-white py-2 px-4 text-center  text-base"
                    onClick={goToVitalHistory}
                  >
                    Send Vitals
                  </button>
                  <button
                    className=" border-2 bg-blue-800 rounded-[18px] text-white py-2 px-4 text-center  text-base"
                    onClick={goToDocHistory}
                  >
                    Share Documents
                  </button>
                </div>
              </div>
              <div className="p-4  shadow-sm w-full bg-neutral-100 rounded-[18px] border">
                <div className="font-semibold mb-2">Payment details</div>
                <div className="flex justify-between items-center mb-1">
                  <span>Appointment fee</span>
                  <span>₹ 0.00</span>
                </div>
                <div className="border-b border-dashed border-gray-400 my-2"></div>
                <div className="flex justify-between items-center font-semibold">
                  <span>Total</span>
                  <span>₹ 0.00</span>
                </div>
              </div>
            </>
          )}
        </div>
        <div className="bg-white h-16 fixed bottom-0 w-full pt-1 flex justify-center">
          <button
            onClick={handlePayment}
            className="  w-11/12 h-14 p-3 bg-blue-800 rounded-[18px] text-white font-semibold"
          >
            <div className="flex justify-center items-center  w-full">
              {isLoading && <Spinner className="mr-2 h-4 w-4 animate-spin" />}{" "}
              Book appointment
            </div>
          </button>
        </div>
      </div>
    </>
  );
}
